import HotelHitContentBodyMeals from './HotelHitContentBodyMeals.js';
import HotelHitLink from './HotelHitLink.js';
import { HotelHitContentBodyContainer, HotelHitContentBodyContent, UspList, UspListItem, GuestRatingContainer } from './styles/hotelHitContentBody.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import GuestRating from '../../GuestRating/GuestRating.js';
import TripAdvisorRating from '../../TripAdvisorRating/TripAdvisorRating.js';

var HotelHitContentBody = function HotelHitContentBody(_ref) {
  var _ref$bodyContent = _ref.bodyContent,
    uspList = _ref$bodyContent.uspList,
    tripAdvisor = _ref$bodyContent.tripAdvisor,
    guestRating = _ref$bodyContent.guestRating,
    _ref$bodyContent$text = _ref$bodyContent.texts,
    guestRatingText = _ref$bodyContent$text.guestRatingText,
    tripAdvisorText = _ref$bodyContent$text.tripAdvisorText,
    mealsTexts = _ref$bodyContent$text.mealsTexts,
    href = _ref.href,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/jsxs(HotelHitContentBodyContainer, {
    children: [(href || onSelect) && /*#__PURE__*/jsx(HotelHitLink, {
      href: href,
      onSelect: onSelect
    }), /*#__PURE__*/jsxs(HotelHitContentBodyContent, {
      children: [uspList && /*#__PURE__*/jsx(UspList, {
        children: uspList.map(function (usp) {
          return /*#__PURE__*/jsxs(UspListItem, {
            children: [usp.name, ": ", usp.value]
          }, usp.name);
        })
      }), /*#__PURE__*/jsxs(GuestRatingContainer, {
        children: [guestRating && /*#__PURE__*/jsx(GuestRating, {
          responsive: true,
          rating: guestRating,
          text: guestRatingText
        }), tripAdvisor && /*#__PURE__*/jsx(TripAdvisorRating, {
          hideRatingDesktop: true,
          text: tripAdvisorText,
          rating: tripAdvisor.rating,
          responsive: true,
          className: "sg-hotel-hit__trip-advisor-rating"
        })]
      })]
    }), /*#__PURE__*/jsx(HotelHitContentBodyMeals, {
      texts: mealsTexts
    })]
  });
};
HotelHitContentBody.defaultProps = {
  bodyContent: null,
  href: null,
  onSelect: null
};
var HotelHitContentBody$1 = HotelHitContentBody;

export { HotelHitContentBody$1 as default };
//# sourceMappingURL=HotelHitContentBody.js.map
